<template>
  <LiveAccountDetails page-label="Trading Account Details" />
</template>

<script>
import LiveAccountDetails from "@/views/account/LiveAccountDetails.vue";

export default {
  name: "Mt5Details",
  components: {
    LiveAccountDetails,
  },
};
</script>
